<template>
  <div>
    <h6>{{ question.label }} {{ question.required ? '*' : '' }}</h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-form-group>
      <b-form-select
        v-model="answer"
        :options="values"
        :disabled="disabled"
      ></b-form-select>
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
  function decode(value) {
    if (!value) return [undefined, undefined, undefined]
    let parts = value.split('&')
    let start = decodeURIComponent(parts[0])
    let end = decodeURIComponent(parts[1])
    let label = parts.length > 2 ? decodeURIComponent(parts[2]) : undefined
    return [start, end, label]
  }
  function encode(start, end, label) {
    if (!start || !end) return null
    return _.compact([
      encodeURIComponent(start),
      encodeURIComponent(end),
      label ? encodeURIComponent(label) : undefined
    ]).join('&')
  }
  function normalize(value) {
    if (!value) return value
    let [start, end, label] = decode(value)
    return encode(start, end, label)
  }

  export default {
    props: {
      value: String, // {start}&{end}&{label} where start and end are YYYY-MM-DD
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      return {
        trans: trans,
        answer: normalize(this.value || null)
      }
    },
    computed: {
      values() {
        let values = (this.question.options.values || []).map((range, index) => {
          let label = this.question.options.labels &&
            this.question.options.labels[index] ?
            this.question.options.labels[index] :
            null
          let text = _.compact([
            label,
            moment(range.start).format('LL') + ' - ' + moment(range.end).format('LL'),
          ]).join(', ')
          let value = encode(range.start, range.end, label)
          return {
            value: value,
            text: text,
          }
        })
        values.unshift({
          value: null,
          text: this.question.placeholder || '',
          disabled: this.question.required,
          selected: !this.answer
        })
        return values
      },
    },
    watch: {
      answer() {
        if (this.value != this.answer) this.$emit('input', this.answer)
      },
      value() {
        this.answer = normalize(this.value || null)
      },
    },
    mounted() {
      window['questionDateRangeSelection'+this.question.id] = this
    },
  }
</script>